import DirectusClient from "../../lib/directus-sdk/index.js";
import { LOCAL_STORAGE_KEY } from "../Foundation.js";

const clientDirectus = new DirectusClient("/cms");

clientDirectus.autoAuthSync(LOCAL_STORAGE_KEY.APP_DATA, (data) => ({
  token: data.directusToken,
}));

function prestigeClientConfig() {
  const prestigeClient = clientDirectus.clone();
  prestigeClient.setFilter( "translations", "prestige_locales_id", "code", "lang");

  return prestigeClient;
}

export const prestigeClient = prestigeClientConfig();



// WEBPACK FOOTER //
// ./src/app/common/directus/index.js